@if (screeningReportOwnershipData$ | async; as screeningReportOwnershipData) {
  @switch (screeningReportOwnershipData?.viewType) {
    @case (ownershipViews.Direct) {
      <div class="color-blue">
        {{ 'company_ownership.direct.title' | translate }}
      </div>
    }
    @case (ownershipViews.Classes) {
      <div class="color-blue">
        {{ 'company_ownership.direct.title' | translate }}
      </div>
    }
    @case (ownershipViews.Indirect) {
      <div class="color-blue">
        {{ 'company_ownership.indirect.title' | translate }}
      </div>
    }
    @case (ownershipViews.Ultimate) {
      <div class="color-blue">
        {{ 'company_ownership.ultimate.title' | translate }}
      </div>
    }
    @case (ownershipViews.Beneficial) {
      <div class="color-blue">
        {{ 'company_ownership.beneficial.title' | translate }}
      </div>
      <div>
        <em>
          {{
            'screening.screening_overrides.export.company_information.company_ownership.beneficial_description'
              | translate
          }}
        </em>
      </div>
    }
  }
  <br />
}

@if (ownershipComposites$ | async; as ownershipComposites) {
  @if (ownershipComposites.length) {
    <table>
      <tbody>
        @for (composite of ownershipComposites; track composite.shareholderName) {
          <tr>
            <td>
              @if (composite.person) {
                <nk-person-title [person]="composite.person" [showFlag]="false"></nk-person-title>
              } @else if (composite.company) {
                <nk-company-title [company]="composite.company" [showFlag]="false"></nk-company-title>
              } @else {
                <span>{{ composite.shareholderName }}</span>
              }
            </td>
            <td>{{ composite.ownership | percentage }}</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    {{ 'common.no_data' | translate }}
  }
}
